module.exports = __webpack_public_path__ + "static/img/097_TO8_1774.c7b176e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/097_TO8_1774.jpg
// module id = pLUP
// module chunks = 0